import axios from "axios";

const ArticleRejectHooks = (data) => {
  return new Promise((resolve) => {
    axios
      .put(`${process.env.REACT_APP_NODE_URL}/orders/update`, {
        doi_id: data.doi_id,
        updateData: data.rejected_reason,
      })
      .then((res) => resolve(res))
      .catch((err) => console.log(err));
  });
};

export default ArticleRejectHooks;
